<template>
  <div class="modal-backdrop" v-if="show">
    <div class="modal">
      <h5 class="description">Projet</h5>
      <form>
        <b-row class="col-12" style="display:flex;">
          <label class="btn col-6" for="6" :class="{ active: neuf == true || habiter == true }" style="flex:0.5">
            Neuf
            <input class="radio" id="6" type="button" @click="change('Neuf')" value="Neuf" v-model="selected" />
          </label>
          <label class="btn col-6" for="7" :class="{ active: ancien == true }" style="flex:0.5">
            Ancien
            <input class="radio" id="7" type="button" @click="change('Ancien')" value="Ancien" v-model="selected" />
          </label>
        </b-row>

        <div class="col-12" v-if="ancienBien != true">
          <b-row class="col-12" style="display:flex;">
            <label class="btn col-6" for="0" :class="{ active: habiter == true }" style="flex:0.5">
              Habiter
              <input class="radio" id="0" type="button" @click="change('Habiter')" value="Habiter" v-model="selected" />
            </label>
            <label class="btn col-6" for="1" :class="{ active: pinel == true && habiter == false}" style="flex:0.5">
              Investir
              <input class="radio" id="1" type="button" @click="change('Pinel')" value="Pinel" v-model="selected" />
            </label>
          </b-row>

        
          <div class="col-12" v-if="habiter != true">
            <h5 class="description">Investissement</h5>
            <div style="display:flex">
              <label class="btn" for="2" :class="{ active: pinel == true }" style="flex:0.3">
                Pinel
                <input class="radio" id="2" type="button" @click="change('Pinel')" value="Pinel" v-model="selected" />
              </label>

              <label class="btn" for="3" :class="{ active: lmnp == true || lmnpAmort == true || lmnpCensi == true }" style="flex:0.7">
                LMNP / LMP
                <input class="radio" id="3" type="button" @click="change('LMNP / LMP')" value="LMNP / LMP" v-model="selected" />
              </label>  
            </div>
          </div>
          

          <div class="col-12"  v-if="lmnp == true || lmnpAmort == true || lmnpCensi == true">
            <h5 class="description">Dispositif</h5>
            <div style="display:flex; flex-direction: column">
              <label class="btn" for="4" :class="{ active: lmnpAmort == true }">
                LMNP Amortissement
                <input class="radio" id="4" type="button" @click="change('LMNP Amortissement')" value="LMNP Amortissement" v-model="selected" />
              </label>

          
              <label class="btn" for="5" :class="{ active: lmnpCensi == true }">
                LMNP Censi-Bouvard
                <input class="radio" id="5" type="button" @click="change('LMNP Censi-Bouvard')" value="LMNP Censi-Bouvard" v-model="selected" />
              </label>
            </div>
          </div>

          <div class="col-12" v-if="lmnpAmort == true || lmnpCensi == true">
            <template>
            <h5 class="description">Résidence</h5>
              <div class="col-12"> 
                <Select
                v-model="residence"
                description=""
                :options="ListeResidence"
                label="text"
                placeholder=""
              />
              </div>
            </template>
          </div>
          <div class="col-12">
            <template v-if="lmnpAmort == true && lmnpCensi == false">
            <h5 class="description">Type</h5>
              <div class="col-12"> 
                <Select
                v-model="typeResidence"
                description=""
                :options="ListeTypeResidence"
                label="text"
                placeholder=""
              />
              </div>
            </template>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Select from "./Select";
//import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  mounted() {
    
  },
  data() {
    return {
      selected: null,
      projet: ["Habiter", "Investir", "Pinel", "LMNP / LMP", "LMNP Amortissement", "LMNP Censi-Bouvard","Neuf","Ancien"],
      residence :0,
      ListeResidence: [
          {text: "Toutes", value: 0, selected: 0},
          {text: "Affaire", value: 1},
          {text: "EHPAD", value: 2},
          {text: "Senior", value: 3},
          {text: "Etudiante", value: 4},
          {text: "Tourisme", value: 5},
      ],
      typeResidence: 0,
      ListeTypeResidence: [
          {text: "Neuf et Ancien", value: 0, selected: 0},
          {text: "Neuf", value: 1},
          {text: "Ancien", value: 2},
      ],
      ancienBien: false,
      neuf: false
    };
  },
  props: {
    show: {
      type: Boolean
    },
    habiter: {
      type: Boolean
    },
    ancien: {
      type: Boolean
    },
    pinel: {
      type: Boolean
    },
    lmnp: {
      type: Boolean
    },
    lmnpAmort: {
      type: Boolean
    },
    lmnpCensi: {
      type: Boolean
    },

  },
  methods: {
    change(proj) {

      switch(proj) {
        case "Neuf":
          this.neuf=true
          this.ancienBien=false
          this.habiter = true
          this.pinel = false
          this.lmnp = false
          this.lmnpAmort = false
          this.lmnpCensi = false
          this.selected = this.projet[6]
          break
        case "Ancien":
          this.neuf=false
          this.ancienBien=true
          this.habiter = false
          this.pinel = false
          this.lmnp = false
          this.lmnpAmort = false
          this.lmnpCensi = false
          this.selected = this.projet[7]
          break
        case "Habiter":
          this.habiter = true
          this.neuf=true
          this.ancienBien = false
          this.pinel = false
          this.lmnp = false
          this.lmnpAmort = false
          this.lmnpCensi = false
          this.selected = this.projet[0]
          break
        case "Pinel":
          this.habiter = false
          this.neuf=true
          this.ancienBien = false
          this.pinel = true
          this.lmnp = false
          this.lmnpAmort = false
          this.lmnpCensi = false
          this.selected = this.projet[2]
          break
        case "LMNP / LMP":
          this.habiter = false
          this.neuf=true
          this.ancienBien = false
          this.pinel = false
          this.lmnp = true
          this.lmnpAmort = true
          this.lmnpCensi = false
          this.selected = this.projet[3]
          break
        case "LMNP Amortissement":
          this.habiter = false
          this.neuf=true
          this.ancienBien = false
          this.pinel = false
          this.lmnp = true
          this.lmnpAmort = true
          this.lmnpCensi = false
          this.selected = this.projet[4]
          break
        case "LMNP Censi-Bouvard":
          this.habiter = false
          this.neuf=true
          this.ancienBien = false
          this.pinel = false
          this.lmnp = true
          this.lmnpAmort = false
          this.lmnpCensi = true
          this.selected = this.projet[5]
          break
      }
      this.$emit('selectedProject', {selectedProj: this.selected, residence: this.residence, typeResidence: this.typeResidence})
    },
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          //document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
    habiter(value){
      this.selected = this.projet[0]
    },
    ancien(value){
      this.ancienBien = value
      this.selected = this.projet[7]
    },
    pinel(value){
      this.selected = this.projet[2]
    },
    lmnp(value){
      this.selected = this.projet[3]
    },
    lmnpAmort(value){
      this.selected = this.projet[4]

    },
    lmnpCensi(value){
      this.selected = this.projet[5]
    },
  },
  computed: {
  },
  components: {
    Select
  }
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: absolute;
  .modal {
    width: 100%;
    background-color: #f2fdff;
    border-radius: 5px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    margin-top: 15px;
    .description {
      margin: 0px;
      margin-bottom: 5px;
      color: #22abc5;
      /* font-weight: normal; */
      font-size: 13px;
      margin-top: 10px;
      font-weight: normal;
    }

    .btn {
      cursor: pointer;
      margin: 10px;
      padding: 10px;
      border: 1px solid #22abc5;
      color: #ffffff;
      background-color: #22abc5;
      border-radius: 5px;
      text-align: center;
      font-family: Metropolis;
      &.active {
        border: 1px solid #ff8c00;
        color: #ffffff;
        background-color: darkorange;
      }
      .radio {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .modal-backdrop {
  position: initial;
  .modal{
    width: 150px;
  }
  }
}

#residence, #typeresidence {
    color: #b5bcbd;
    background-color: white;
    padding: 7px;
    width: 89%;
    border-radius: 7px;
    border-color: #8c9a9c;
    margin-top: 0px;
    margin-left:3%;
    &:focus {
      outline: 0;
    }
    &::placeholder {
      color: #22a1b9;
    }
    .option {
      font-size: 10px;
    }
  }

</style>
